export default __webpack_public_path__ + "static/urban-truant-7f1dc2dd9c2375c77a0b1230ff28a2c8.jpg";